import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import LabeledInput from '../LabeledInput';

import defaultStyles from '../../styles/formSetStyles.module.css';

interface GroupInput {
  label: string;
  element: JSX.Element;
  labelFor?: string;
}

interface Props extends React.PropsWithChildren {
  classNames?: string[];
  inputs?: GroupInput[];
  title?: string;
}

export const GroupInputs: React.FC<Props> = ({
  classNames,
  inputs,
  title,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(defaultStyles.FormDiv, ...(classNames || []))}>
      {title ? <div className={defaultStyles.SubLabel}>{t(title)}</div> : <></>}
      {inputs
        ? inputs.map(({ label, labelFor, element }, index) => (
            <LabeledInput label={label} htmlFor={labelFor} key={index}>
              {element}
            </LabeledInput>
          ))
        : children}
    </div>
  );
};
